<template>
<div id='navigation_header' class='top-navigation-container'>
    <DemoBanner v-if='show_demo_banner'/>
    <div class='header-bar'>
        <div class='nav-bar-items'>
            <div class='mobile-menu-container'>
                <MobileMenu :menu_items='menu_items' :headings='headings' :sub_headings='sub_headings'/>
            </div>
            <Logo/>
            
            <div class='right-container'>
                <Search/>
                <!-- <Location/> -->
                <Favourites/>
                <Account/>
                <Basket :updated_cart_watcher='updated_cart_watcher'/>
            </div>

        </div>
       
    </div>
    <DesktopMenuBar :menu_items='menu_items' :headings='headings' :sub_headings='sub_headings'/>
    <PrerenderedMenu :headings='headings'/>
    
</div>
</template>

<script>
import DesktopMenuBar from '@/ecom/components/navigation/header/menus/DesktopMenuBar.vue';
import DemoBanner from '@/ecom/components/navigation/header/DemoBanner.vue';
import Search from '@/ecom/components/navigation/header/search/Search.vue';
import Basket from '@/ecom/components/navigation/header/basket/Basket.vue';
import Account from '@/ecom/components/navigation/header/Account.vue';
import Favourites from '@/ecom/components/navigation/header/Favourites.vue';
import Location from '@/ecom/components/navigation/header/Location.vue';
import Logo from '@/ecom/components/navigation/header/Logo.vue';
import MobileMenu from '@/ecom/components/navigation/header/menus/MobileMenu.vue';
import PrerenderedMenu from '@/ecom/components/navigation/header/menus/PrerenderedMenu.vue';

import {checkAuth} from "@/global/modules/functions.js";

export default {
    components: {DesktopMenuBar, Search, Basket, Account, Logo, MobileMenu, Favourites, Location, DemoBanner, PrerenderedMenu},
    props: ['updated_cart_watcher'],
        data(){
            return{
                menu_items:[],
                headings: [],
                sub_headings:[],
                items: [],
                show_demo_banner: false
            }
        },
    methods:{
        async getMenuItems(){
            let response = await fetch(`/api/nav-bar/menu-items`, {
                method: 'GET',
                credentials: 'include'
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                this.menu_items = results.menu_items;
                this.formatMenuData();

                this.show_demo_banner = results.show_demo_banner;
                if(this.show_demo_banner){
                    document.querySelector(':root').style.setProperty('--demo-banner-message-height', '35px');
                }
            }
        },
        formatMenuData(){
            this.headings = this.menu_items.filter(x=>x.parent_id == 0);

            for (let i = 0; i < this.headings.length; i++) {
                let sub_headings = this.menu_items.filter(x=>x.parent_id == this.headings[i].id);
                this.headings[i].sub_headings = sub_headings;

                for (let j = 0; j < this.headings[i].sub_headings.length; j++) {
                    let items = this.menu_items.filter(x=>x.parent_id == this.headings[i].sub_headings[j].id);
                    this.headings[i].sub_headings[j].menu_items = items;
                }
            }
        }
    },
    // beforeMount(){
    //     this.getMenuItems();
    // },
    created(){
        this.getMenuItems();
    }
}
</script>

<style lang="scss" scoped>

.top-navigation-container{
    position: fixed; 
    width: 100%; 
    display: flex; 
    flex-direction: column; 
    z-index: 99;
}
.header-bar {
	// background-color: var(--primary-colour-2);
	background-color: white;
	color: var(--top-nav-bar-text-colour);
    height: var(--top-nav-bar-height);
    align-content: center;
    padding-left: 20px;

    @media(max-width: 768px){
        padding-left: 0px;
    }
    // padding-right: 20px;
}

.nav-bar-items{
    color: black;
    display: flex;
    justify-content: space-between;
    font-size: 0.95rem;
    padding-left: 20px;
    padding-right: 20px;
    align-items: center;
}

.right-container{
    display: flex;
    gap: 22px;
    align-items: center;
    justify-content: flex-end;

    @media(max-width: 768px){
        gap: 20px;
        flex-grow: 1;
    }
}

.mobile-menu-container{
    display: none;

    @media(max-width: 768px){
        display: block;
        margin-right: 10px;
    }
}
</style>